import { render, staticRenderFns } from "./EnterProjectInformation.vue?vue&type=template&id=6b3ada5e"
import script from "./EnterProjectInformation.vue?vue&type=script&lang=js"
export * from "./EnterProjectInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports